import { render, staticRenderFns } from "./addRechargeSetting.vue?vue&type=template&id=24dac151&scoped=true"
import script from "./addRechargeSetting.vue?vue&type=script&lang=js"
export * from "./addRechargeSetting.vue?vue&type=script&lang=js"
import style0 from "./addRechargeSetting.vue?vue&type=style&index=0&id=24dac151&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dac151",
  null
  
)

export default component.exports